






































































































import { Component, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  ReserveReserveInfo,
  InputReserveItem,
  defaultInputReserveItem
} from '@/components/organisms/ReserveReserveInfo'
import { ReserveListTable } from '@/components/organisms/ReserveListTable'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { ModalForwardingRequest } from '@/components/modals/ModalForwardingRequest'
import {
  ForwardingRequestInfo,
  InputForwardingRequestItem,
  defaultInputForwardingRequestItem
} from '@/components/organisms/ForwardingRequestInfo'
import {
  Alert,
  AlertMessage,
  AuthUser,
  collectionApi,
  defaultReserveContactInfo,
  defaultSystemCode,
  ErrorMessage,
  reserveApi,
  ReserveContactInfo,
  SimpleBibliographyReal,
  SimpleCollection
} from '@/api'
import {
  alertStore,
  modalErrorStore,
  authUserStore,
  systemParameterStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { ModalReserveCancel } from '@/components/modals/ModalReserveCancel'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import {
  AlertCodeAL300047,
  AlertCodeAL300062,
  AlertCodeTL700020,
  ReceiptPrintName,
  SearchType
} from '@/types'
import { BibliographyRealInfoSimple } from '@/components/organisms/BibliographyRealInfoSimple'
import { AlertFactory } from '@/factory'
import { ReserveReceipt } from '@/api/models/reserve/ReserveReceipt'
import { CommandType } from '@/types/websocket'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import CODE_KEY from '@/config/code_key'

@Component({
  components: {
    BibliographyRealInfoMagazine,
    BibliographyRealInfoSimple,
    ReserveReserveInfo,
    ReserveListTable,
    ForwardingRequestInfo,
    ModalForwardingRequest,
    ModalReserveCancel,
    ModalFooter,
    InputDatePicker
  }
})
export default class ModalReserveEdit extends ComponentVue {
  dialog: boolean = false

  reserveItem: ReserveContactInfo = defaultReserveContactInfo()

  inputForwardingRequestItem: InputForwardingRequestItem = defaultInputForwardingRequestItem()

  inputReserve: InputReserveItem = defaultInputReserveItem()

  get authUser(): AuthUser {
    return authUserStore.authUser
  }

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  get simpleBibliographyReal(): SimpleBibliographyReal {
    return {
      bibliographyClass: this.reserveItem.bibliography.bibliographyClass,
      prefix: this.reserveItem.bibliography.prefix,
      bibliographyId: this.reserveItem.bibliography.bibliographyId,
      searchType: this.reserveItem.bibliography.searchType,
      displayMaterialFormat: this.reserveItem.bibliography
        .displayMaterialFormat,
      displayClass: this.reserveItem.bibliography.displayClass,
      displayTitle: this.reserveItem.bibliography.displayTitle,
      displaySubtitle: '',
      displayAuthor: this.reserveItem.bibliography.displayAuthor,
      volume: this.reserveItem.bibliography.volume,
      volumeNumber: this.reserveItem.bibliography.volumeNumber,
      volumeTotal: this.reserveItem.bibliography.volumeTotal,
      volumeDateLabel: this.reserveItem.bibliography.volumeDateLabel,
      volumeSpecial: this.reserveItem.bibliography.volumeSpecial,
      displayPublisher: this.reserveItem.bibliography.displayPublisher,
      displayPublished: '',
      displaySize: '',
      bibliographySetId: this.reserveItem.bibliography.bibliographySetId,
      marcType: defaultSystemCode(),
      marcNo: '',
      holdingCount: this.reserveItem.bibliography.holdingCount,
      orderCount: this.reserveItem.bibliography.orderCount,
      reserveCount: this.reserveItem.bibliography.reserveCount,
      collectionFlag: this.reserveItem.bibliography.collectionFlag,
      isbn10: '',
      isbn13: ''
    }
  }

  get userId() {
    return this.reserveItem.user.id
  }

  get reserveStatusIsReceiveWaiting() {
    return this.reserveItem.reserve.reserveStatus.code === '1'
  }

  get reserveStatusIsForwarding() {
    return this.reserveItem.reserve.reserveStatus.code === '3'
  }

  get reserveStatusIsReturnWaiting() {
    return this.reserveItem.reserve.reserveStatus.code === '4'
  }

  get reserveStatusIsForwardingRequest() {
    return this.reserveItem.reserve.reserveStatus.code === '5'
  }

  get isUpdateReservePreparation(): boolean {
    return systemParameterStore.isUpdateReservePreparation
  }

  open(reserveId: number): void {
    systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.PROCESSING_PLACE.KEY])
    systemParameterStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.RETURNED_RESERVE_STATUS_SETTING.KEY,
      CODE_KEY.MOBILE_LIBRARY_PROCESSING_PLACE.KEY
    ])
    this.firstFetchReserveInfo(reserveId)
  }

  close(): void {
    this.dialog = false
  }

  setInputData() {
    this.inputReserve = defaultInputReserveItem()

    this.inputReserve.reserveSpecifyBranch.input = this.reserveItem.reserve.reserveSpecifyBranchCodes

    this.inputReserve.specifyCollectionNo.input = this.reserveItem.reserve.specifyCollectionNo

    if (this.reserveItem.reserve.reserveSpecifyBranchCodes.length > 0) {
      this.inputReserve.reserveMethod.input = '2'
    } else if (this.reserveItem.reserve.specifyCollectionNo !== '') {
      this.inputReserve.reserveMethod.input = '3'
    } else {
      this.inputReserve.reserveMethod.input = '1'
    }

    this.inputReserve.reserveBranch.input = this.reserveItem.reserve.registrationBranchCode
    this.inputReserve.reservePlace.input = this.reserveItem.reserve.registrationPlaceCode
    this.inputReserve.forwardingBranch.input = this.reserveItem.reserve.forwardingBranchCode
    this.inputReserve.forwardingPlaceCode.input = this.reserveItem.reserve.forwardingPlaceCode
    this.inputReserve.reserveRegistrationDate.input = this.reserveItem.reserve.registrationTime.substr(
      0,
      8
    )
    this.inputReserve.preferredDate.input = this.reserveItem.reserve.preferredDate
    this.inputReserve.reserveExpiration.input = this.reserveItem.reserve.reserveExpiration
    this.inputReserve.noticeAllowed.input = this.reserveItem.reserve.reserveNoticeAllowed
    this.inputReserve.contactMethod.input = this.reserveItem.reserve.contactMethod
    this.inputReserve.memo.input = this.reserveItem.reserve.displayMemo
  }

  setForwardingRequest() {
    this.inputForwardingRequestItem = defaultInputForwardingRequestItem()
    this.inputForwardingRequestItem.requestLevel.input = this.reserveItem.reserve.forwardLevel
    this.inputForwardingRequestItem.requestBranch.input = this.reserveItem.reserve.forwardRequestBranchCodes
    this.inputForwardingRequestItem.requestMemo.input = this.reserveItem.reserve.forwardMemo
  }

  async firstFetchReserveInfo(reserveId: number): Promise<void> {
    await this.fetchReserveInfoInterface(reserveId, true)
  }

  async reconfigureReserveInfo(reserveId: number): Promise<void> {
    await this.fetchReserveInfoInterface(reserveId, false)
    this.inputReserve.reserveExpiration.input = this.reserveItem.reserve.reserveExpiration // 入力できる項目の中ではここだけ更新しているので修正
  }

  async fetchReserveInfoInterface(reserveId: number, isFirstFetch: boolean) {
    try {
      this.reserveItem = await reserveApi.getReserveContactInfo(reserveId)

      if (isFirstFetch) {
        this.setInputData()
        this.setForwardingRequest()
        this.dialog = true
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async getSimpleCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.inputReserve.specifyCollectionNo.input
        }
      )

      this.$modalCollectionSelect.open({
        collectionNo: this.inputReserve.specifyCollectionNo.input,
        simpleCollections: collections,
        onClickOk: (id: number) => {
          if (this.reserveStatusIsForwardingRequest) {
            this.forwardingRequestUpdate(id)
          } else {
            this.reserveUpdate(id)
          }
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async reserveUpdate(collectionId: number = 0) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const receipt: ReserveReceipt = await reserveApi.reserveUpdate({
        id: this.reserveItem.reserve.id,
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3' ? collectionId : 0,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' && collectionId === 0
            ? this.inputReserve.specifyCollectionNo.input
            : '',
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input,
        reserveRegistrationPlaceCode: this.inputReserve.reservePlace.input,
        forwardingBranchCode: this.inputReserve.forwardingBranch.input,
        forwardingPlaceCode: this.inputReserve.forwardingPlaceCode.input,
        reserveRegistrationDate: this.inputReserve.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserve.preferredDate.input,
        reserveExpiration: this.inputReserve.reserveExpiration.input,
        reserveNoticeAllowed: this.inputReserve.noticeAllowed.input,
        contactMethod: this.inputReserve.contactMethod.input,
        displayMemo: this.inputReserve.memo.input
      })
      if (receipt.receiptInfoReserve !== undefined) {
        this.$webSocket.sendReceiptPrintMessage({
          command: CommandType.ReceiptPrintReserve,
          name: ReceiptPrintName.ReceiptPrintReserve,
          data: receipt.receiptInfoReserve,
          subject: `利用者番号：${receipt.receiptInfoReserve.user_id}`
        })
      }
      if (receipt.receiptInfoReserveForwarding !== undefined) {
        this.$webSocket.sendReceiptPrintMessage({
          command: CommandType.ReceiptPrintReserveForwarding,
          name: ReceiptPrintName.ReceiptPrintReserveForwarding,
          data: receipt.receiptInfoReserveForwarding,
          subject: `資料番号：${receipt.receiptInfoReserveForwarding.collection_no}`
        })
      }

      this.$emit('updated')
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeTL700020
        ) {
          await this.getSimpleCollection()
          return
        }
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async forwardingRequestUpdate(collectionId: number = 0) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.forwardingRequestUpdate({
        id: this.reserveItem.reserve.id,
        forwardingRequestLevel: this.inputForwardingRequestItem.requestLevel
          .input,
        forwardingRequestMemo: this.inputForwardingRequestItem.requestMemo
          .input,
        forwardingRequestBranch: this.inputForwardingRequestItem.requestBranch
          .input,
        reserveMethod: this.inputReserve.reserveMethod.input,
        reserveSpecifyBranch:
          this.inputReserve.reserveMethod.input === '2'
            ? this.inputReserve.reserveSpecifyBranch.input
            : [],
        specifyCollectionId:
          this.inputReserve.reserveMethod.input === '3' ? collectionId : 0,
        specifyCollectionNo:
          this.inputReserve.reserveMethod.input === '3' && collectionId === 0
            ? this.inputReserve.specifyCollectionNo.input
            : '',
        reserveRegistrationBranchCode: this.inputReserve.reserveBranch.input,
        reserveRegistrationPlaceCode: this.inputReserve.reservePlace.input,
        forwardingBranchCode: this.inputReserve.forwardingBranch.input,
        forwardingPlaceCode: this.inputReserve.forwardingPlaceCode.input,
        reserveRegistrationDate: this.inputReserve.reserveRegistrationDate
          .input,
        preferredDate: this.inputReserve.preferredDate.input,
        reserveExpiration: this.inputReserve.reserveExpiration.input,
        reserveNoticeAllowed: this.inputReserve.noticeAllowed.input,
        contactMethod: this.inputReserve.contactMethod.input,
        displayMemo: this.inputReserve.memo.input
      })

      this.$emit('updated')
      this.close()
    } catch (error) {
      if (
        error.alerts.length === 1 &&
        error.alerts[0].code === AlertCodeTL700020
      ) {
        await this.getSimpleCollection()
        return
      }

      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setErrorMessage(alerts: Alert[]) {
    alerts.forEach(alert => {
      switch (alert.attribute) {
        case 'forwarding_request_level':
          this.inputForwardingRequestItem.requestLevel.errorMessage =
            alert.message
          break
        case 'forwarding_request_memo':
          this.inputForwardingRequestItem.requestMemo.errorMessage =
            alert.message
          break
        case 'forwarding_request_branch_codes':
          this.inputForwardingRequestItem.requestBranch.errorMessage =
            alert.message
          break
        case 'reserve_specify_branch_codes':
          this.inputReserve.reserveSpecifyBranch.errorMessage = alert.message
          break
        case 'specify_collection_no':
          this.inputReserve.specifyCollectionNo.errorMessage = alert.message
          break
        case 'reserve_registration_branch_code':
          this.inputReserve.reserveBranch.errorMessage = alert.message
          break
        case 'reserve_registration_date':
          this.inputReserve.reserveRegistrationDate.errorMessage = alert.message
          break
        case 'reserve_registration_place_code':
          this.inputReserve.reservePlace.errorMessage = alert.message
          break
        case 'preferred_date':
          this.inputReserve.preferredDate.errorMessage = alert.message
          break
        case 'reserve_expiration':
          this.inputReserve.reserveExpiration.errorMessage = alert.message
          break
        case 'contact_method':
          this.inputReserve.contactMethod.errorMessage = alert.message
          break
        case 'forwarding_branch_code':
          this.inputReserve.forwardingBranch.errorMessage = alert.message
          break
        case 'forwarding_place_code':
          this.inputReserve.forwardingPlaceCode.errorMessage = alert.message
          break
        case 'display_memo':
          this.inputReserve.memo.errorMessage = alert.message
          break
      }
    })
  }

  onClickOk() {
    let alertMessage = ''

    if (
      this.reserveStatusIsReceiveWaiting &&
      this.inputReserve.forwardingBranch.input.code !==
        this.reserveItem.reserve.forwardingBranchCode.code
    ) {
      alertMessage = '予約回送中'
    }

    if (
      this.reserveStatusIsForwarding &&
      this.inputReserve.forwardingBranch.input.code !==
        this.reserveItem.reserve.forwardingBranchCode.code &&
      this.inputReserve.forwardingBranch.input.code ===
        this.authUser.branchCode.code
    ) {
      alertMessage = '予約受取待'
    }

    if (alertMessage) {
      const alert: Alert = AlertFactory.create(AlertCodeAL300047, alertMessage)
      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: () => {
          this.update()
        }
      })
    } else {
      this.update()
    }
  }

  update() {
    if (this.reserveStatusIsForwardingRequest) {
      this.forwardingRequestUpdate()
    } else {
      this.reserveUpdate()
    }
  }

  onClickRevertReserveToPreparation(): void {
    alertStore.setItem(AlertFactory.create(AlertCodeAL300062, '予約受取準備中'))
    this.$modalAlert.open({
      onOkClick: this.revertReserveToPreparation
    })
  }

  async revertReserveToPreparation(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await reserveApi.updateReserveToPreparation({
        id: this.reserveItem.reserve.id
      })
      await this.reconfigureReserveInfo(this.reserveItem.reserve.id)
      this.$emit('updated')
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-reserve-edit')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  @Emit('edit')
  onClickEdit(): void {}

  @Emit('rank-change')
  onClickRankChange(): void {}

  @Emit('registration')
  onClickRegistration(): void {}
}
